<template>
    <div class="row h-100 justify-content-center align-items-center bg-danger">
        <div class="col-11 col-sm-8">
            <h1>Ingrese sus datos</h1>
            <input type="text" class="form-control form-control-lg mt-4" v-model="user.name" placeholder="Nombre">
            <input type="email" class="form-control form-control-lg mt-4" v-model="user.email" placeholder="Email">
            <button class="btn btn-primary btn-lg mt-4" :disabled="disabled" @click="start">Comenzar</button>
        </div>
    </div>
</template>

<script>
import router from '../router'
import { mapActions } from 'vuex'

export default {
    props: ['company'],
    data() {
        return {
            user: {
                name: null,
                email: null
            }
        }
    },
    computed: {
        disabled: function() {
            return (this.user.name === null || this.user.email === null)
        },
    },
    methods: {
        start() {
            this.clearAnswers()
            this.setUser(this.user)
            router.push({ name: 'Questions', params: { number: 0, company: this.company } })
        },
        ...mapActions([
            'clearAnswers',
            'setUser'
        ])
    },
}
</script>
